import { foolproofTerm } from '@app/utils/filter/terms/foolproof-term';
import { Term } from '@app/utils/filter/terms/term';

export function termToString(term: Term): string {
  let stringified = '';

  if (term.operator === 'gt') {
    stringified = `${term.key}>${term.arguments[0]}`;
  } else if (term.operator === 'gte') {
    stringified = `${term.key}>=${term.arguments[0]}`;
  } else if (term.operator === 'lt') {
    stringified = `${term.key}<${term.arguments[0]}`;
  } else if (term.operator === 'lte') {
    stringified = `${term.key}<=${term.arguments[0]}`;
  } else if (term.operator === 'match') {
    stringified = foolproofTerm(term.arguments[0]);
  } else if (term.operator === 'in') {
    const foolproofedArguments = term.arguments.map((_) => foolproofTerm(_));

    stringified = `${term.key}:` + foolproofedArguments.join(',');
  }

  return stringified;
}
